import type { PublicUser } from '@cult/schemas';
import { create } from 'zustand';

type CurrentUserState = {
  user: PublicUser | null;
  setUser: (user: PublicUser | null) => void;
  clearUser: () => void;
};

export const useCurrentUser = create<CurrentUserState>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  clearUser: () => set({ user: null }),
}));
